import React, { useEffect, useState } from "react";
// import StarIcon from "@mui/icons-material/Star";
// import StarHalfIcon from "@mui/icons-material/StarHalf";
// import StarBorderIcon from "@mui/icons-material/StarBorder";
import vegBadge from "../../../media/images/veg-badge.webp";
import veganBadge from "../../../media/images/vegan-badge.webp";
import nonVegBadge from "../../../media/images/non-veg-badge.webp";
import RemoveIcon from "@mui/icons-material/Remove";
import AddIcon from "@mui/icons-material/Add";
import { useDispatch, useSelector } from "react-redux";
import { addCart, deleteCart, editQtyCart } from "../../../redux/actions/checkout";
import CircularProgress from "@mui/material/CircularProgress";
import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded";
import noImg from "../../../media/images/no-img.png";
import useWindowSize from "../../../hooks/useWindowSize";

export default function MenuCard(props) {
  const { data, addDisabled, setmoreInfo, setmoreInfoPopup } = props;
  const { id, name, img, price, type, ratings, bestseller } = data;

  const dispatch = useDispatch();
  const { cart } = useSelector((state) => state.checkout);
  const [imgLoaded, setimgLoaded] = useState(false);
  const { activeOutlet } = useSelector((state) => state.config);
  const { width } = useWindowSize();

  function getCount() {
    let detectCount = 0;
    cart.forEach((item) => {
      if (item.id === id) {
        detectCount = item.qty;
      }
    });

    return detectCount;
  }

  // const starSize = 12;

  function onClickAdd() {
    dispatch(addCart({ id, name, img, price, type, ratings, qty: 1 }));
  }

  useEffect(() => {
    if (getCount() === 0) {
      dispatch(deleteCart(id));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getCount()]);

  function onClickSub() {
    dispatch(editQtyCart({ id, qty: getCount() - 1 }));
  }

  function onClickPlus() {
    dispatch(editQtyCart({ id, qty: getCount() + 1 }));
  }

  return (
    <div
      className="menu-card"
      style={{
        padding: img || window.innerWidth >= 600 ? "1rem" : "2rem 1rem 2rem 2rem",
      }}
    >
      {(img || window.innerWidth >= 600) && (
        <div
          className="img-card"
          style={{
            backgroundColor: imgLoaded ? "transparent" : "var(--color-grey-opaque)",
          }}
        >
          {!imgLoaded && (
            <div className="spinner-container">
              <CircularProgress className="spinner" size="3rem" />
            </div>
          )}
          <img src={img ? img : noImg} alt={name} onLoad={() => setimgLoaded(true)} loading="lazy" />
          {imgLoaded && <div className="bg-gradient" />}
          {bestseller && <div className="best-seller">BESTSELLER</div>}
        </div>
      )}
      <div className="card-actions">
        <div className="name">
          <p>{name}</p>
        </div>
        <div className="details">
          <div className="price">
            <p>{activeOutlet.outletCurrency}</p>
            <h3>{price ? price.toFixed(2) : ""}</h3>
          </div>

          <div className="badge">
            {type === "veg" && <img src={vegBadge} alt="veg badge" />}
            {type === "vegan" && <img src={veganBadge} alt="vegan badge" />}
            {type === "nonveg" && <img src={nonVegBadge} alt="non-veg badge" />}
          </div>
        </div>
        <div className="bottom">
          <div
            className="more-info"
            onClick={() => {
              setmoreInfo(data);
              setmoreInfoPopup(true);
            }}
          >
            <p>More Info</p>
            <ChevronRightRoundedIcon />
          </div>
          {getCount() === 0 ? (
            <div className="btn" onClick={!addDisabled ? onClickAdd : null}>
              ADD
            </div>
          ) : (
            <div className="btn-selected">
              <div className="sub" onClick={onClickSub}>
                <RemoveIcon style={{ fontSize: 15 }} />
              </div>
              <div className="num">{getCount()}</div>
              <div className="add" onClick={onClickPlus}>
                <AddIcon style={{ fontSize: 15 }} />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
